'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Endpoints = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Endpoints = exports.Endpoints = {
    production: 'https://api.wixrestaurants.com/v1.1'
};

var parseSuccess = function parseSuccess(response) {
    if (response.data) {
        if (response.data.error) {
            return _q2.default.reject({
                error: {
                    code: response.data.error,
                    description: response.data.errorMessage
                }
            });
        } else if (response.data.value) {
            return _q2.default.resolve(response.data.value);
        } else {
            return _q2.default.reject({
                error: {
                    code: 'protocol',
                    description: 'protocol error'
                }
            });
        }
    } else {
        return _q2.default.reject({
            error: {
                code: 'protocol',
                description: 'protocol error'
            }
        });
    }
};

var parseError = function parseError(error) {
    if (error.response) {
        return _q2.default.reject({
            error: {
                code: 'protocol',
                description: 'protocol error'
            }
        });
    } else {
        switch (error.code) {
            case 'ECONNABORTED':
                return _q2.default.reject({
                    error: {
                        code: 'timeout',
                        description: 'request timed out'
                    }
                });
            case 'ENOTFOUND': // fall through
            default:
                return _q2.default.reject({
                    error: {
                        code: 'network_down',
                        description: 'network is down'
                    }
                });
        }
    }
};

var WixRestaurantsClient = function () {
    function WixRestaurantsClient() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$endpointUrl = _ref.endpointUrl,
            endpointUrl = _ref$endpointUrl === undefined ? Endpoints.production : _ref$endpointUrl,
            _ref$timeout = _ref.timeout,
            timeout = _ref$timeout === undefined ? 0 : _ref$timeout;

        _classCallCheck(this, WixRestaurantsClient);

        this._endpointUrl = endpointUrl;
        this._axios = _axios2.default.create({
            timeout: timeout,
            headers: {
                'content-type': 'application/json'
            }
        });
    }

    _createClass(WixRestaurantsClient, [{
        key: 'getOrganization',
        value: function getOrganization(_ref2) {
            var organizationId = _ref2.organizationId,
                _ref2$fields = _ref2.fields,
                fields = _ref2$fields === undefined ? null : _ref2$fields;

            return this._request({
                type: 'get_organization',
                organizationId: organizationId,
                fields: fields
            });
        }
    }, {
        key: 'getOrganizationFull',
        value: function getOrganizationFull(_ref3) {
            var organizationId = _ref3.organizationId,
                _ref3$fields = _ref3.fields,
                fields = _ref3$fields === undefined ? null : _ref3$fields;

            return this._request({
                type: 'get_organization_full',
                organizationId: organizationId,
                fields: fields
            });
        }
    }, {
        key: 'setOrganization',
        value: function setOrganization(_ref4) {
            var organization = _ref4.organization,
                accessToken = _ref4.accessToken;

            return this._request({
                type: 'set_organization',
                organization: organization,
                accessToken: accessToken
            });
        }
    }, {
        key: 'submitOrder',
        value: function submitOrder(_ref5) {
            var _ref5$accessToken = _ref5.accessToken,
                accessToken = _ref5$accessToken === undefined ? null : _ref5$accessToken,
                order = _ref5.order;

            return this._request({
                type: 'submit_order',
                accessToken: accessToken,
                order: order
            }).then(function (orderConfirmation) {
                return orderConfirmation.order;
            });
        }
    }, {
        key: 'getRole',
        value: function getRole(_ref6) {
            var accessToken = _ref6.accessToken,
                organizationId = _ref6.organizationId;

            return this._request({
                type: 'get_role',
                accessToken: accessToken,
                organizationId: organizationId
            });
        }
    }, {
        key: '_request',
        value: function _request() {
            var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this._axios.post(this._endpointUrl, request).then(parseSuccess, parseError);
        }
    }]);

    return WixRestaurantsClient;
}();

exports.default = WixRestaurantsClient;


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-restaurants-js-sdk/dist/clients/WixRestaurantsClient.js
// module id = 371
// module chunks = 0